const circularNext = (arr: any[], item: string) => {
  const i : number = arr.indexOf(item);
  return i > -1 && i < arr.length - 1 ? arr[i + 1] : arr[0]
}

const getNextView = (views: string[], currentView: string): string => circularNext(views, currentView)

const viewSwitcherInit = (): void => {
  
  const viewSwitcher = document.querySelector('[data-view-switcher]') as HTMLElement

  if (!viewSwitcher) return

  const views = viewSwitcher.dataset.views.split(',').map(view => view.trim())
  const viewHolder  = document.querySelector(viewSwitcher.dataset.viewHolder) as HTMLElement

  if (!viewHolder || !views) return

  
  const setView = (view: string) => window.localStorage.setItem('blubolt:listing-view', view)
  const getView = () => window.localStorage.getItem('blubolt:listing-view')

  const setViewAndClass = (view: string) => {
    setView(view)
    viewHolder.classList.remove(...views)
    viewHolder.classList.add(view)
  }

  setViewAndClass(getView())
  
  viewSwitcher.addEventListener('click', () => {
    const currentView = getView()
    const nextView = getNextView(views, currentView)
    setViewAndClass(nextView)
  })
}

export default viewSwitcherInit